export { default } from './BuyFromDataSourceInline';
